module.exports = __webpack_public_path__ + "static/media/Review_CBCT_tab.7a2280c4.mp4";